import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { reconClient } from '../../../utils/axios';

// GET /api/v1/results — paged rows of the current dbt snapshot for ONE
// classification (the API requires it; there is no "all" view).
export const fetchResults = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await reconClient.get('/results', { params, skipErrorSnackbar: true });
  return data;
};

export const useGetResultsHandler = ({
  classification,
  filters = {},
  page = 0,
  pageSize = 20,
  enabled = true,
} = {}) => {
  const dispatch = useDispatch();

  const params = {
    classification,
    ...filters,
    limit: pageSize,
    offset: page * pageSize,
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['recon-results', params],
    queryFn: fetchResults,
    enabled: enabled && Boolean(classification),
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      const message = error?.response?.data?.detail ?? error?.message ?? 'Failed to load reconciliation results';
      dispatch(showSnackbar({ message, severity: 'error' }));
    }
  }, [dispatch, error, isError]);

  return {
    results: data?.items ?? [],
    totalResults: data?.total ?? 0,
    snapshot: data?.snapshot ?? null,
    isLoading,
  };
};
